<div 
  [formGroup]="form()"
  class="more__terms-form-field"
>
  <label class="terms-form-field__label ci-paragraph-p1-semibold">
    <input 
      class="terms-form-field__checkbox"
      type="checkbox" 
      [formControlName]="formControlName()" 
    />
    {{ 'He leído y acepto los términos y condiciones de uso' | translate }}*
  </label>
</div>

